/**
 * Styled Components - Created by miguelcanobbio on 13/07/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { GRAY_LIGHT, GRAY_SOFT, GRAY_STRONG, WHITE } from '../../../theme/colors'

export const Container = styled.div`
  cursor: pointer;
  display: flex;
  flex-flow: column;
  border-bottom: 1px solid ${GRAY_LIGHT};
  padding-bottom: 16px;
  padding-top: 22px;
  &:nth-child(even) {
    background: #f9f9f9;
  }
  &:hover {
    background-color: #e6e6e5;
  }
`

interface CellProps {
  color?: string
  textAlign?: string
}

export const Cell = styled.div`
  text-align: left;
  color: ${({ color }: CellProps) => (color ? color : '#5f6062')};
  font-size: 13.5px;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  margin-right: 8px;
  font-weight: 500;
  font-family: Avenir;
`

export const CellTight = styled.div`
  text-align: left;
  color: ${({ color }: CellProps) => (color ? color : '#5f6062')};
  font-size: 13.5px;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  font-weight: 500;
  font-family: Avenir;
`

export const AmountLabel = styled.div`
  color: #5db62c;
  text-align: right;
  font-weight: bold;
  font-family: Avenir;
`

export const CellLabel = styled.div`
  color: ${GRAY_SOFT};
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: normal;
  font-family: Avenir;
`

export const CellMobile = styled.div`
  text-align: left;
  color: ${({ color }: CellProps) => (color ? color : '#565656')};
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  font-family: Avenir;
  font-size: 14px;
  margin-right: 24px;
  font-weight: bold;
  font-family: Avenir;
`

export const EditButton = styled.div`
  border: 1px solid ${GRAY_SOFT};
  color: ${GRAY_STRONG};
  font-size: 12px;
  transition: all .25s;
  border-radius: 3px;
  margin: 0 16px;
  text-align: center;
  transition: all .25s;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    background: ${GRAY_SOFT};
    color: ${WHITE};
  }
`

export const EditIcon = styled(Icon)`
  background: #ffd277;
  margin-left: 18px;
  font-size: 14px;
  padding: 5px;
  border-radius: 3px;
  color: ${WHITE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const DeleteButton = styled.div`
  color: ${GRAY_SOFT};
  font-size: 13px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CellSecondary = styled.div`
  border-bottom: 1px solid #d7d7d7;
  text-align: left;
  padding: 8px 0;
  color: ${({ color }: CellProps) => (color ? color : '#5f6062')};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 35px;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};

  @media (min-width: 331px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 12px;
  }

  @media (max-width: 330px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 11px;
  }
  @media (max-width: 640px) {
    position: relative;
  }
`

export const DuePayment = styled.div`
  text-align: center;
  font-size: 10px;
  background: #6fc17b;
  width: fit-content;
  margin: 0 auto;
  padding: 0 8px;
  border-radius: 3px;
  height: 24px;
  display: flex;
  align-items: center;
  color: white;
  @media (max-width: 1252px) {
    width: max-content;
  }
  @media (max-width: 640px) {
    text-align: center;
    font-size: 10px;
    background: #6fc17b;
    margin: 0 auto;
    padding: 0 8px;
    height: 24px;
    display: flex;
    align-items: center;
    color: white;
    position: absolute;
    right: 0;
    bottom: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border-top-left-radius: 14px;
    border-top-right-radius: 0px;
  }
`

export const TruckIcon = styled.img`
  max-width: 34px;
  margin-right: 34px;
  @media (max-width: 640px) {
    margin-right: 20px;
  }
`

export const UpperSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
  position: relative;
`

export const BottomSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`

export const ImportedIcon = styled(Icon)`
  font-size: 10px;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 25px;
  padding: 3px;
  border: 1px solid #dcd1f6;
  box-shadow: none;
  margin-left: 10px;
  position: absolute;
  left: -8px;
  top: -18px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OrderHistory/ItemOrderMobile/styledComponents.tsx